import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperService } from '../helper.service';
import { News } from '../news.model';
import { NewsService } from '../news.service';
import { ToastService } from '../toasts.service';

@Component({
  selector: 'app-news-form',
  templateUrl: './news-form.component.html',
  styleUrls: ['./news-form.component.css']
})
export class NewsFormComponent implements OnInit {
  //declare variables
  news: any;
  strID: string = '';

  //inject services
  constructor(private route: ActivatedRoute, private ns: NewsService, private router: Router, private hs: HelperService, private tst: ToastService) { }

  //initialize the component
  ngOnInit(): void {
    //initialize the news item
    this.news = new News();

    //get the parameter for the lead
    this.route.paramMap.subscribe(p => {
      //lead ID
      this.strID = p.get('id');

      //retrieve the lead
      this.ns.find(this.strID).subscribe(data => {
        this.news = data;
      });
    });
  }

  //save any updates
  save() {
    //see if a new record or an update to an existing record
    if (this.strID == '' || this.strID == null) {
      //create the GUID
      this.news.id = this.hs.createGUID();
      //save the record
      this.ns.save(this.news);
      //alert the user
      this.tst.show('News item saved successfully.', 'Save', 'fas fa-save', { classname: 'bg-success text-white text-center toaster', delay: 2000 });
    } else {
      //update the record
      this.ns.update(this.strID, this.news);
      //alert the user
      this.tst.show('News item updated successfully.', 'Update', 'fas fa-edit', { classname: 'bg-success text-white text-center toaster', delay: 2000 });
    }
  }

  //return to previous page
  back() {
    this.router.navigate(['/news']);
  }

}
